import ProductsAdmin from "../../../Components/Admin/Products";

const ProductsAdminPage = () => {
  return <ProductsAdmin />;
};

export default ProductsAdminPage;
